import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import difference from 'lodash-es/difference';
import { TradeStoreService } from './trade-store.service';
@Directive({
    selector: '[tradeClass]',
    standalone: true
})
export class TradeClassDirective implements OnChanges {
    /**
     * Classes
     *
     * m-r-5 !m-r-6 means m-r-5 for trade and m-r-6 for non trade
     */
    @Input()
    tradeClass: string;
    /**
     * Applied classes list
     */
    private classes: string[] = [];
    /**
     * Dependencies
     */
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private tradeStoreService: TradeStoreService
    ) {}
    /**
     * On changes hook
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tradeClass']) {
            const classesRaw = this.tradeClass.split(' ').filter(i => !!i);
            const isTrade = this.tradeStoreService.isTradeStore();
            const classes = isTrade ? classesRaw.filter(i => i[0] !== '!') : classesRaw.filter(i => i[0] === '!').map(i => i.substring(1));
            difference(this.classes, classes).forEach(className => this.renderer.removeClass(this.elementRef.nativeElement, className));
            difference(classes, this.classes).forEach(className => this.renderer.addClass(this.elementRef.nativeElement, className));
            this.classes = classes;
        }
    }
}
